import React, { useContext } from 'react';
import LinkButton from '../../LinkButton';
import { useWeddingWebsiteQuery, WeddingWebsiteQuery, WeddingWebsiteQueryDocument } from '../../../generated/graphql';
import { usePublishWeddingWebsiteMutation } from '../../../generated/graphql';
import { useClient } from '../../../apollo/ApolloClientsProvider';
import styles from './PublishWebsiteBanner.scss';
import PublishWebsiteModal from '../PublishWebsiteModal/PublishWebsiteModal';
import { TrackingContext } from '../../../TrackingContext';

interface Prop {
  rightRailOpen?: boolean;
  setShowPublishedIndexBanner?: (visible: boolean) => void;
}

const PublishWebsiteBanner: React.FC<Prop> = ({ rightRailOpen = false, setShowPublishedIndexBanner }) => {
  const { data: wwsData } = useWeddingWebsiteQuery();
  const isUserEmailVerified = wwsData?.member?.isEmailVerified || false;
  const isWebsitePublished = wwsData?.weddingWebsite?.state === 'published';
  const client = useClient();
  const [publishWeddingWebsite] = usePublishWeddingWebsiteMutation();
  const [shouldRenderPublishModal, setShouldRenderPublishModal] = React.useState(false);

  const { track } = useContext(TrackingContext);

  const onPublishWebsite = async () => {
    const { data } = await publishWeddingWebsite();

    const newWebsiteState = data?.publishWeddingWebsite.state;
    const weddingWebsiteQueryResult = client.readQuery<WeddingWebsiteQuery>({
      query: WeddingWebsiteQueryDocument,
    });

    if (!newWebsiteState || !weddingWebsiteQueryResult) {
      return false;
    }

    client.writeQuery<WeddingWebsiteQuery>({
      query: WeddingWebsiteQueryDocument,
      data: {
        ...weddingWebsiteQueryResult,
        weddingWebsite: {
          ...weddingWebsiteQueryResult?.weddingWebsite,
          state: newWebsiteState,
        },
      },
    });

    return true;
  };

  const onPublishWebsiteButtonClick = async () => {
    if (!isUserEmailVerified) {
      track('Wedding Website Enabled', { success: false });
      return setShouldRenderPublishModal(true);
    }

    const wasPublishSuccessful = await onPublishWebsite();
    setShouldRenderPublishModal(true);
    setShowPublishedIndexBanner?.(true);
    track('Wedding Website Enabled', { success: wasPublishSuccessful });
    if (!wasPublishSuccessful) {
      track('Wedding Website Enabled', { success: 'false' });
      return;
    }
    track('Wedding Website Enabled', { success: 'true' });
  };

  return (
    <>
      {!isWebsitePublished && (
        <div className={rightRailOpen ? styles.eipPublishWebsiteBanner : styles.publishWebsiteBanner}>
          <LinkButton onClick={onPublishWebsiteButtonClick}>Publish your website</LinkButton> when you’re ready to show
          it off.
        </div>
      )}
      {shouldRenderPublishModal && <PublishWebsiteModal onClose={() => setShouldRenderPublishModal(false)} />}
    </>
  );
};

export default PublishWebsiteBanner;
